

export default {
    equipmentOrders: [],
    totalEquipmentOrders: 0,
    equipmentOrdersFiltered: [],

}
 